<p>help-topic works!</p>
<ckeditor [editor]="Editor"
    [config]="{ toolbar: [ 'heading', '|', 'bold', 'italic','|', 'undo', 'redo','|','bulletedList', 'numberedList', 'blockQuote'  ] }"
    data="<p>Hello, world!</p>" (change)="onChange($event)">
</ckeditor>